$(document).on('scroll', function(e){
	let scrollTop = $(this).scrollTop(),
		header = $('.header'),
		winH = $(window).innerHeight(),
		section4 = $('.customer-count').length ? $('.customer-count') : false;
	
	(scrollTop >= 100) ? header.addClass('is-fixed') : header.removeClass('is-fixed');

	if (section4) {
		let _pos = section4.offset().top,
			_pos2 = (_pos - (winH * 3 / 4));
		(scrollTop >= (_pos2 - 25) && scrollTop <= (_pos2 + 25)) ? section4.addClass('start-counter') : section4.removeClass('start-counter');

		if (section4.hasClass('start-counter')) {
			$('.js-countUp').each(function() {
				let _this = $(this);
				countUp(_this);
			});
		}
	}

	section();
	// parallaxBackground($('.banner-page'), .15, "right ");
});
